module.exports = __webpack_public_path__ + "6172405f9a4e5f0e752d7dc21f173974.svg";